import axios from '../utils/AxiosInstance'

export default {
  // namespaced: true,
  state: {
    templatemails: {
      selectIds: [],
      filters: {},
      paginate: {},
      selectId: false
    }
  },
  mutations: {
    SET_TEMPLATEMAIL_SELECT_IDS (store, ids) {
      store.templatemails.selectIds = ids
    },
    REMOVE_TEMPLATEMAIL_SELECT_IDS (store, ids) {
      store.templatemails.selectIds = store.templatemails.selectIds.filter((v) => { return !ids.includes(v) })
    },
    SET_TEMPLATEMAIL_SELECT_ID (store, id) {
      store.templatemails.selectId = id
    },
    SET_TEMPLATEMAIL_FILTERS (store, filters) {
      store.templatemails.filters = filters
    },
    SET_TEMPLATEMAIL_PAGINATE (store, val) {
      store.templatemails.paginate = {
        limit: val.limit,
        page: val.page,
        pages: val.pages,
        total: val.total
      }
    }
  },
  getters: {
    getTemplatemails: (store, getters) => {
      return store.templatemails.selectIds.map((id) => {
        return getters['entities/templatemails/find'](id)
      })
    },
    getTemplatemailsFilters: (store, getters) => {
      return store.templatemails.filters
    },
    getTemplatemailsPaginate: (store, getters) => {
      return store.templatemails.paginate
    },
    getTemplatemail: (store, getters) => {
      return getters['entities/templatemails/find'](store.templatemails.selectId) || {}
    }
  },
  actions: {
    /*
    selectTemplatemails
    */
    selectTemplatemails ({commit, dispatch, getters, state}, filters) {
      return dispatch('getTemplatemails', filters)
      .then((response) => {
        commit('SET_TEMPLATEMAIL_FILTERS', filters)
        commit('SET_TEMPLATEMAIL_PAGINATE', response)
        commit('SET_TEMPLATEMAIL_SELECT_IDS', response.docs.map((item) => { return item._id }))
        return response
      })
    },
    /*
    refreshSelectTemplatemails
    */
    refreshSelectTemplatemails ({commit, dispatch, getters, state}) {
      return dispatch('selectTemplatemails', getters.getTemplatemailsFilters)
    },
    /*
    selectTemplatemail
    */
    selectTemplatemail ({commit, dispatch, getters, state}, id) {
      return dispatch('getTemplatemailById', id)
      .then((response) => {
        commit('SET_TEMPLATEMAIL_SELECT_ID', response._id)
        return response
      })
    },
    /*
    getTemplatemails
    */
    getTemplatemails ({commit, dispatch, getters, state}, filters) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/templatemails`, {params: filters})
      .then((response) => {
        return dispatch('entities/templatemails/insert', {
          data: response.data.docs
        })
        .then((result) => {
          return {
            docs: result.templatemails || [],
            limit: response.data.limit,
            page: response.data.page,
            pages: response.data.pages,
            total: response.data.total
          }
        })
      })
    },
    /*
    getTemplatemailById
    */
    getTemplatemailById ({commit, dispatch, getters, state}, id) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/templatemails/${id}`)
      .then((response) => {
        return dispatch('entities/templatemails/insert', {
          data: response.data
        })
      })
      .then((result) => {
        return result.templatemails[0]
      })
    },
    /*
    createTemplatemail
    */
    createTemplatemail ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .post(`/accounts/${getters.getAccount._id}/templatemails`, data)
      .then((response) => {
        return dispatch('entities/templatemails/insert', {
          data: response.data
        })
      })
      .then((response) => {
        return response.templatemails[0]
      })
    },
    /*
    updateTemplatemail
    */
    updateTemplatemail ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .put(`/accounts/${getters.getAccount._id}/templatemails/${data._id}`, data)
      .then((response) => {
        return dispatch('entities/templatemails/insert', {
          data: response.data
        })
      })
      .then((response) => {
        return response.templatemails[0]
      })
    },
    /*
    deleteTemplatemail
    */
    deleteTemplatemail ({commit, dispatch, getters, state}, id) {
      return axios
      .delete(`/accounts/${getters.getAccount._id}/templatemails/${id}`)
      .then((response) => {
        commit('REMOVE_TEMPLATEMAIL_SELECT_IDS', [id])
        dispatch('entities/templatemails/delete', id)
        return {}
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/Templatemail.js